const BookableVenueKind = Object.freeze({
  NEVER: Object.freeze([
    'park',
    'beach',
    'hiking_area',
    'market',
    'night_club',
    'spa',
    'restaurant',
    'cafe',
    'bar',
  ] as const),
  TICKETED: Object.freeze(['museum', 'zoo_aquarium', 'amusement_park', 'theatre'] as const),
  LANDMARK: Object.freeze(['historical_landmark', 'tourist_attraction'] as const),
} as const);

export type BookableVenueKind = (typeof BookableVenueKind)[keyof typeof BookableVenueKind][number];

export default BookableVenueKind;
